export default __webpack_public_path__ + "static/media/Josh Gorman Resume.e3c003ed.pdf";